import ProjectsProxy from '@/proxies/Projects';
import ProjectsTransform from '@/transforms/Projects';
import ProgressTransform from '@/transforms/Progress';
import * as types from './mutation-types';

export default {
  async getItems({ commit, dispatch, getters }) {
    commit(types.LOADING, true);
    const proxy = new ProjectsProxy();
    try {
      const response = await proxy.getProjects(getters.sort);
      commit(types.PROJECTS, ProjectsTransform.fetchCollection(response.jobs).filter(item => !!item));
      commit(types.MORE, response.total > getters.items.length);
      commit(types.TOTAL, response.total);
      dispatch('getProgress');
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_projects', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async getItem({ commit, dispatch, getters }, payload) {
    commit(types.LOADING, true);
    const proxy = new ProjectsProxy();
    try {
      const response = await proxy.find(payload);
      const result = [...getters.items, ProjectsTransform.fetch(response)];
      commit(types.ADD_PROJECT, result);
      commit(types.MORE, true);
      commit(types.TOTAL, result.length);
    } catch (e) {
      dispatch('notification/error', ['errormessage.failed_to_get_project', { project_id: payload.id }], { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  addProject({ commit }, payload) {
    commit(types.PROJECTS, [payload]);
  },

  async deleteItem({ commit, state }, payload) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.delete(payload);
      commit(types.DELETE, payload);
      const deletionCount = Array.isArray(payload) ? payload.length : 1;
      commit(types.TOTAL, state.total - deletionCount);
    } catch (e) {
      // TODO
    }
  },

  async getLogs({ commit, dispatch, getters }, payload) {
    const page = payload?.page || getters.logsPage;
    const limit = payload?.limit || getters.logsLimit;
    if (getters.logsTotal && page > Math.ceil(getters.logsTotal / limit)) {
      return
    }

    try {
      commit(types.SET_LOGS_LOADING, true);
      const proxy = new ProjectsProxy();
      const { logs = [], total } = await proxy.getTaskStatuses({ limit, page });
      const formatLogs = ProjectsTransform.fetchStatuses(logs);
      const items = payload?.reset ? formatLogs : [ ...getters.logsItems, ...formatLogs ];

      commit(types.SET_LOGS, {
        ...getters.logs,
        items,
        limit,
        page,
        total,
      });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_logs', { root: true });
    } finally {
      commit(types.SET_LOGS_LOADING, false);
    }
    return;

    if (!items.length) {
      return
    }

    const dif = result.filter(el2 => {
      const res = !items.some((el1 => (`${el2.updated_at}-${el2.status}` === `${el1.updated_at}-${el1.status}`)));
      return res ? el2.status === 'finished' : res;
    });
    if (!!dif.length) {
      dif.forEach(el => {
        dispatch('notification/success', `${el.game}: ${el.message}`, { root: true });
      });
    }
  },

  getLogsDefer({ dispatch }, payload = 5) {
    setTimeout(() => dispatch('getLogs'), payload * 1000);
  },

  getLogsLoop({ dispatch }) {
    setInterval(() => dispatch('getLogs'), 15000);
  },

  sortItems({ commit, dispatch }, payload) {
    commit(types.SORT, payload);
    dispatch('getItems');
  },

  clearItems({ commit }) {
    commit(types.CLEAR_ITEMS);
  },

  async refresh({ commit, dispatch, getters }) {
    const proxy = new ProjectsProxy();
    try {
      const response = await proxy.getProjects({ ...getters.sort, ...{ page: 1 } });
      commit(types.PROJECTS, ProjectsTransform.fetchCollection(response.jobs));
      dispatch('getProgress');

    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_projects', { root: true });
    }
  },

  refreshProject({ commit, dispatch, getters }, payload) {
    commit(types.LOADING, true);
    try {
      const transformResp = ProjectsTransform.fetch(payload);
      const result = getters.items.map(el => {
        return el.id === transformResp.id ? { ...el, ...transformResp } : el;
      });
      dispatch('project/self', transformResp, { root: true });
      commit(types.ADD_PROJECT, result);
    } catch (e) {
      dispatch('notification/error', ['errormessage.failed_to_get_project', { project_id: payload }], { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async getProgress({ commit, dispatch, getters }) {
    try {
      const job_ids = getters.pendingProgressUpdate;
      if (!job_ids.length) {
        return;
      }
      const params = { job_ids };
      const proxy = new ProjectsProxy();
      const { progress } = await proxy.getProgressForJobs(params);
      const formatProgress = ProgressTransform.fetchCollection(progress);
      const result = getters.items.map(el => {
        const job = formatProgress[el.id];
        return job ? { ...el, ...job } : el;
      });
      commit(types.REMOVE_PENDING_PROGRESS, result);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_progress', { root: true });
    }
  },

  async generateTracksVideo({ dispatch }, payload) {
    const { type = 'tracks' } = payload;
    const proxy = new ProjectsProxy();
    let job_id = !!payload.job_id ? payload.job_id : payload;
    let notify = !!payload.notify ? payload.notify : false;
    const params = { job_id, type };

    try {
      await proxy.generateTracksVideo(params);
      if (notify) {
        dispatch('notification/success', 'confirmationmessage.tracks_processing_started', { root: true });
      }
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_process_request', { root: true });
    }
  },
};
